import { useQueryClient, useMutation } from '@tanstack/react-query';
import { QUERY_KEY_MAP } from 'src/constants';
import { useNotification, useGetUserDetails } from 'src/hooks';
import {
  DeleteAndReingestSchema,
  reingestorDeleteAndReingestPromise,
} from 'src/utils/api/reingestor/reingestor-delete-and-reingest';

export const useReingestorDeleteAndReingest = () => {
  const { userDetails } = useGetUserDetails();

  const { enqueueErrorNotification, enqueueSuccessNotification } = useNotification();

  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: reingestorDeleteAndReingestPromise,
  });

  const deleteAndReingestAsync = async (param: Omit<DeleteAndReingestSchema, 'email_address'>) => {
    try {
      const result = await mutateAsync({
        ...(param || {}),
        email_address: userDetails?.email || '',
      });

      if (!result) {
        enqueueErrorNotification('delete.reingest.failed');
        return result;
      }

      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_MAP.useListTasks],
      });

      enqueueSuccessNotification('delete.reingest.success');
      return result;
    } catch (e) {
      enqueueErrorNotification('delete.reingest.failed');

      console.error('~ file: useReingestorDeleteAndReingest.ts:16 ~ deleteAndReingestAsync ~ e:', e);
      return false;
    }
  };

  return {
    deleteAndReingestAsync,
    isLoading: isPending,
  };
};
